const mapElement = document.getElementById("book__map");
const latitude = "50.7578";
const longitude = "-1.5491";

mapboxgl.accessToken =
  "pk.eyJ1IjoicXBpZGRpZ2l0YWwiLCJhIjoiY205bzg0aG94MHExMzJpc2FuMXVtdzhpbCJ9.zJl2Lm2CdewKldDT9sIFCA";
const map = new mapboxgl.Map({
  container: mapElement,
  style: "mapbox://styles/mapbox/streets-v11",
  center: [longitude, latitude],
  zoom: 14,
});

const svgMarker = document.createElement("div");
svgMarker.innerHTML = `
  <svg width="42" height="64" viewBox="0 0 42 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.8,6.2c-3.74-3.8-8.95-6.2-14.75-6.2S10.03,2.4,6.2,6.2C2.36,10.1,0,15.4,0,21.3c0,16,18.39,21.3,19.67,42.7h2.66c1.28-21.3,19.67-26.7,19.67-42.7,0-5.9-2.36-11.2-6.2-15.1Z" fill="#f1ab2f"/><path d="M20.47,19.17h.52c3.55.11,6.51-2.68,6.62-6.23,0-.13,0-.26,0-.39.1-3.13-2.1-5.87-5.18-6.46-.22-.79-1.05-1.26-1.84-1.03-.5.14-.89.53-1.03,1.03-3.09.58-5.29,3.33-5.18,6.47-.07,2.36,1.17,4.57,3.21,5.75-.55.76-.84,1.68-.83,2.62-.01.94.28,1.86.84,2.62-2.05,1.18-3.29,3.39-3.23,5.75-.11,3.13,2.08,5.87,5.15,6.47.15.81.94,1.34,1.75,1.19.6-.11,1.08-.59,1.19-1.19,3.07-.6,5.25-3.34,5.15-6.47.11-3.54-2.68-6.51-6.22-6.61-.13,0-.27,0-.4,0h-.48c-.75-.25-1.24-.98-1.19-1.78-.04-.77.42-1.48,1.14-1.75ZM20.7,25.07c2.18-.16,4.08,1.47,4.24,3.64.01.2.01.4,0,.6.14,2.17-1.51,4.05-3.68,4.19-.09,0-.17,0-.26,0-2.18,0-3.95-1.77-3.95-3.95,0-.08,0-.17,0-.25-.16-2.18,1.47-4.08,3.64-4.24ZM17.06,13.16c-.01-.2-.01-.4,0-.6-.14-2.18,1.52-4.05,3.69-4.19.08,0,.16,0,.25,0,2.18,0,3.95,1.76,3.95,3.94,0,.08,0,.17,0,.25.16,2.18-1.47,4.08-3.64,4.24-2.18.16-4.08-1.47-4.24-3.64Z" fill="#000000"/>
  </svg>
`;
svgMarker.style.width = "42px";
svgMarker.style.height = "64px";

new mapboxgl.Marker(svgMarker, { anchor: "bottom" })
  .setLngLat([longitude, latitude])
  .addTo(map);
